__turbopack_context__.v({
  "orderInfo": "order-info-module-scss-module__g30uRq__orderInfo",
});
